"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.serialize = serialize;
exports.deserialize = deserialize;
exports.regexMatcher = void 0;
var regexMatcher = /^\/(.*)\/([gimsuy]*)$/;
exports.regexMatcher = regexMatcher;

function serialize(regex) {
  return regex.toString();
}

function deserialize(regex) {
  if (regex instanceof RegExp) {
    return regex;
  }

  var extract = regexMatcher.exec(regex);

  if (!extract) {
    throw new Error("The value ".concat(regex, " doesn't have the correct format. (Example: /([A-Z])\\w+/m)"));
  }

  return new RegExp(extract[1], extract[2]);
}
